import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';
import * as schedulesActions from '../schedules/schedules.actions';
import { UpdateService } from '../../service/update.service';
import * as updateActions from './update.actions';

@Injectable()
export class UpdateEffects {
    constructor(private actions$: Actions, private updateService: UpdateService) { }

    cancel$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateActions.cancelSchedule),
            exhaustMap(action =>
                this.updateService.cancelSchedule(action.cancelSchedule).pipe(
                    map(() => updateActions.cancelScheduleSuccess())
                ))
        ));

    validate$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateActions.validateSchedule),
            exhaustMap(action =>
                this.updateService.validateSchedule(action.validateSchedule).pipe(
                    map(() => updateActions.validateScheduleSuccess())
                ))
        ));

    remove$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateActions.removeSchedule),
            exhaustMap(action =>
                this.updateService.deleteSchedules(action.removeIdSchedules).pipe(
                    map(() => updateActions.removeScheduleSuccess())
                ))
        ));

    validateBookingMember$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateActions.validateBookingMemberSchedule),
            exhaustMap(action => this.updateService.validateManualAccessBookingMemberList(action.idSchedule, action.bookingsMemberId).pipe(
                map(() => updateActions.validateBookingMemberScheduleSuccess({ idSchedule: action.idSchedule }))
            ))
        ));

    successValidateBookingMember$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateActions.validateBookingMemberScheduleSuccess),
            exhaustMap(action => this.updateService.listMembersBooking(action.idSchedule).pipe(
                map((response) => schedulesActions.bookingMembersListSuccess({ bookingMembers: response }))
            ))
        ));

    cancelBookingMember$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateActions.cancelBookingMemberSchedule),
            exhaustMap(action => this.updateService.cancelManualBookingMemberList(action.idSchedule, action.bookingsMemberId).pipe(
                map(() => updateActions.cancelBookingMemberScheduleSuccess({ idSchedule: action.idSchedule }))
            ))
        ));

    successCancelBookingMembe$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateActions.cancelBookingMemberScheduleSuccess),
            exhaustMap(action => this.updateService.listMembersBooking(action.idSchedule).pipe(
                map((response) => schedulesActions.bookingMembersListSuccess({ bookingMembers: response }))
            ))
        ));

    setBookingMember$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateActions.setNewBooking),
            exhaustMap(action => (
                this.updateService
                    .setMemberBooking(action.idBookingMember, action.idSchedule, action.bookedSeat, action.checkPaymentRestriction, action.idMemberFee, action.forceBuyWithCredits)
                    .pipe(
                        map(() => updateActions.setNewBookingSuccess({ idSchedule: action.idSchedule })),
                        catchError(err => {
                            const message = err?.error.errors[0].message || '';

                            return of(updateActions.setNewBookingFailed({ message }));
                        })
                    )
            ))
        ));

    successNewBooking$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateActions.setNewBookingSuccess),
            exhaustMap(action => this.updateService.listMembersBooking(action.idSchedule).pipe(
                map((response) => schedulesActions.bookingMembersListSuccess({ bookingMembers: response }))
            ))
        ));
}
